<template>
  <div class="workbench-header">
    <div class="left">
      <!-- <a-button class="back-btn" @click="emit('back')">
        <ArrowLeftOutlined />
      </a-button> -->
      <img
        src="@/assets/icons/i-return.png"
        style="width: 36px; height: 36px; cursor: pointer"
        @click="emit('back')"
      />
      <a-input :value="keyword" readonly class="search-input">
        <template #prefix>
          <SearchOutlined style="color: #404f69; font-size: 16px" />
        </template>
      </a-input>
    </div>

    <div class="right" v-show="ISshow">
      <a-button
        style="margin: 0 12px"
        @mouseenter="copyHover = true"
        @mouseleave="copyHover = false"
        @click="handleCopy"
      >
        <img
          :src="
            copyHover
              ? require('@/assets/casesearchImg/i-copy-two.png')
              : require('@/assets/casesearchImg/i-copy.png')
          "
          class="icons"
        />
        复制报告
      </a-button>

      <a-dropdown :trigger="['click']">
        <a-button
          @mouseenter="downloadHover = true"
          @mouseleave="downloadHover = false"
          :disabled="downloadDisabled"
        >
          <img
            :src="
              downloadHover
                ? require('@/assets/casesearchImg/i-download-two.png')
                : require('@/assets/casesearchImg/i-download.png')
            "
            class="icons"
          />
          下载
          <DownOutlined />
        </a-button>
        <template #overlay>
          <a-menu @click="handleDownloadClick">
            <!-- <a-menu-item key="pdf">下载 PDF</a-menu-item> -->
            <a-menu-item key="word">下载 Word</a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { message } from "ant-design-vue";
import { SearchOutlined, DownOutlined } from "@ant-design/icons-vue";

const copyHover = ref(false);
const downloadHover = ref(false);

const props = defineProps({
  keyword: {
    type: String,
    default: "",
  },
  ISshow: {
    type: Boolean,
    default: true,
  },
  downloadDisabled: {
    type: Boolean,
    default: false,
  },
  rawMdText: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["back", "download"]);

const handleCopy = () => {
  if (!props.rawMdText) return;
  // 优先使用 Clipboard API（需要 HTTPS），降级使用 execCommand
  if (navigator.clipboard?.writeText) {
    navigator.clipboard
      .writeText(props.rawMdText)
      .then(() => {
        message.success("复制成功");
      })
      .catch(() => {
        message.error("复制失败");
      });
  } else {
    try {
      const textarea = document.createElement("textarea");
      textarea.value = props.rawMdText;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      message.success("复制成功");
    } catch {
      message.error("复制失败");
    }
  }
};

const handleDownloadClick = ({ key }) => {
  emit("download", key);
};
</script>

<style scoped lang="less">
.workbench-header {
  display: flex;

  justify-content: space-between;

  align-items: center;

  height: 58px;

  background: #fff;

  border: 1px solid #e6ecf5;

  border-radius: 10px;

  padding: 0 16px;

  margin-bottom: 16px;
}

.left {
  display: flex;

  align-items: center;

  flex: 1;

  gap: 10px;
}

.back-btn {
  width: 36px;
  height: 36px;
  background-color: #ffffff;
  // color: #fff;
  font-weight: 600;
  /* 图标按钮：去掉 antd 默认左右 padding，flex 居中 */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.search-input {
  height: 40px;
  flex: 1;
  background: rgba(255, 255, 255, 0.88);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #dfe6f2;
  font-weight: 400;
  font-size: 13px;
  color: #3e4d67;
}

.right {
  display: flex;

  gap: 12px;

  font-weight: 600;
  font-size: 13px;
  color: #31425e;
}

.icons {
  width: 20px;
  height: 20px;
}
</style>
